export default __webpack_public_path__ + "static/media/icn-user-profile.371e79ad.svg";